import React, { useEffect, useState } from 'react';
import { Check, X, ShieldCheck, Truck, Clock, AlertCircle, Star } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { TestimonialCard } from '../components/TestimonialCard';
import { FAQItem } from '../components/FAQItem';
import { ImagePlaceholder } from '../components/ImagePlaceholder';
import { StickyCTA } from '../components/StickyCTA';
export function AdvertorialPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowStickyCTA(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    window.location.href = 'https://rizmc0yc6xdf0m9e-94184505724.shopifypreview.com/products/novyra%E2%84%A2-daily-balance-kids';
  };
  return <div className="min-h-screen bg-white text-slate-900 font-sans selection:bg-emerald-100 selection:text-emerald-900" data-id="element-57">
      {/* Navigation / Header Bar */}
      <header className="border-b border-slate-200 bg-white sticky top-0 z-40" data-id="element-58">
        <div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between" data-id="element-59">
          <div className="font-bold text-xl tracking-tight text-slate-900" data-id="element-60">
            Health<span className="text-emerald-600" data-id="element-61">Daily</span>
          </div>
          <div className="text-xs font-medium text-slate-500 uppercase tracking-wider border border-slate-200 px-2 py-1 rounded" data-id="element-62">
            Advertorial
          </div>
        </div>
      </header>

      {/* Main Content with Sidebar Layout */}
      <div className="max-w-7xl mx-auto px-4 py-8 md:py-12" data-id="element-63">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8" data-id="element-64">
          {/* Main Article Content */}
          <main data-id="element-65">
            {/* Article Meta */}
            <div className="mb-8 border-b border-slate-200 pb-8" data-id="element-66">
              <div className="flex items-center gap-2 text-sm text-slate-500 mb-4" data-id="element-67">
                <span className="font-bold text-emerald-700 uppercase tracking-wide text-xs" data-id="element-68">
                  Pediatric Health
                </span>
                <span data-id="element-69">•</span>
                <span data-id="element-70">April 26, 2025</span>
                <span data-id="element-71">•</span>
                <span data-id="element-72">12,847 views</span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight mb-6 tracking-tight" data-id="element-73">
                Pediatric Nutritionist Reveals: Your Child's Focus Problems
                Aren't From ADHD—It's The 'Micronutrient Cascade Collapse' No
                One Talks About
              </h1>

              <div className="flex items-center gap-3" data-id="element-74">
                <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center overflow-hidden" data-id="element-75">
                  <img src="https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=100&h=100" alt="Sarah Mitchell" className="w-full h-full object-cover" data-id="element-76" />
                </div>
                <div data-id="element-77">
                  <div className="font-bold text-slate-900 text-sm" data-id="element-78">
                    By Sarah Mitchell
                  </div>
                  <div className="text-slate-500 text-xs" data-id="element-79">
                    Health & Wellness Reporter
                  </div>
                </div>
              </div>
            </div>

            {/* Article Body */}
            <article className="prose prose-lg prose-slate max-w-none font-serif" data-id="element-80">
              <p className="lead text-xl md:text-2xl text-slate-700 leading-relaxed font-medium mb-8" data-id="element-81">
                If you're a parent of a child with ADHD, you know the feeling.
              </p>

              <p data-id="element-82">
                The daily emails from teachers. The 3-hour homework battles that
                end in tears. The bedtime that somehow takes until 10 PM even
                though you started the routine at 7. The constant, nagging worry
                that never quite goes away: "Am I doing enough?"
              </p>

              <img src="https://cdn.magicpatterns.com/uploads/pG5NrwzQEp5EJrfNhi7iC7/ChatGPT_Image_26_Ιαν_2026,_03_20_58_μ.μ..png" alt="Frustrated parent helping child with homework at kitchen table" className="w-full rounded-xl my-8 shadow-lg" data-id="element-83" />

              <p data-id="element-84">
                You've tried everything. You've cut out food dyes. You've
                established routines. You've hired tutors and therapists. You've
                read every parenting book. You've joined Facebook groups and
                scrolled through Reddit threads at 2 AM looking for answers.
              </p>

              <p className="font-bold text-slate-900" data-id="element-85">
                And yet... the struggles continue.
              </p>

              <p data-id="element-86">
                Your child still can't sit still. Still can't focus. Still melts
                down over seemingly small things. And every single day, you
                wonder what you're missing.
              </p>

              <p data-id="element-87">
                But what if I told you the real problem isn't what you think?
              </p>

              <p data-id="element-88">
                What if it's not purely neurological at all—but a hidden
                nutritional trap that's been making everything worse?
              </p>

              <p data-id="element-89">
                That's exactly what pediatric nutritionist Dr. Sarah Martinez
                discovered when she started investigating why so many ADHD
                children weren't responding to traditional approaches.
              </p>

              <p data-id="element-90">And what she found changes everything.</p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-91">
                The Discovery That Changed Everything
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/8JJqScMCyAnw4GZEwdHsB6/ChatGPT_Image_26_Ιαν_2026,_03_21_03_μ.μ..png" alt="Dr. Sarah Martinez, pediatric nutritionist in clinical setting" className="w-full rounded-xl my-8 shadow-lg" data-id="element-92" />

              <p data-id="element-93">
                Dr. Martinez had been working with families of ADHD children for
                over 15 years. But something was bothering her.
              </p>

              <p data-id="element-94">
                She noticed that children with nearly identical ADHD symptoms
                were having completely different outcomes. Some improved
                dramatically with basic interventions like routine changes and
                dietary adjustments. Others struggled despite doing "everything
                right."
              </p>

              <p data-id="element-95">
                Same diagnosis. Same symptoms. Completely different results.
              </p>

              <p data-id="element-96">
                "What's the difference?" she wondered. "What are we missing?"
              </p>

              <p data-id="element-97">
                So she started running comprehensive micronutrient panels on the
                children who weren't improving. Blood tests that checked for
                vitamin and mineral levels most pediatricians never look at.
              </p>

              <p data-id="element-98">And that's when she discovered something shocking.</p>

              <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 my-8 not-prose rounded-r-lg" data-id="element-99">
                <p className="font-serif text-lg text-emerald-900 italic font-medium m-0" data-id="element-100">
                  "It wasn't that these kids had worse ADHD. It was that their
                  bodies couldn't process out the environmental toxins they were
                  exposed to every single day."
                </p>
              </div>

              <p data-id="element-101">
                The reason? Something she now calls{' '}
                <strong data-id="element-102">"The Micronutrient Cascade Collapse."</strong>
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-103">
                What Is The "Micronutrient Cascade Collapse"?
              </h2>

              <p data-id="element-104">
                Here's what most parents don't realize about their child's body.
              </p>

              <img src="https://cdn.magicpatterns.com/uploads/wNfYoGHAzDgNrKUSkPGw7t/ChatGPT_Image_26_Ιαν_2026,_03_21_04_μ.μ..png" alt="3-Phase Detoxification System diagram showing how the body processes toxins" className="w-full rounded-xl my-8 shadow-lg" data-id="element-105" />

              <p data-id="element-106">
                Think of it like a house with a drainage system. When everything
                works properly, small amounts of toxins from food, water, and
                the environment flow through the body and get cleared out
                naturally. No problem.
              </p>

              <p data-id="element-107">
                But here's the catch: Your child's body has a 3-phase
                detoxification system that needs to work together perfectly.
              </p>

              <ul className="list-none pl-0 space-y-4 my-8 not-prose" data-id="element-108">
                <li className="flex items-start gap-3" data-id="element-109">
                  <div className="bg-emerald-100 text-emerald-700 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1 font-bold text-xs" data-id="element-110">
                    1
                  </div>
                  <span className="text-slate-700" data-id="element-111">
                    <strong className="text-slate-900" data-id="element-112">Phase 1</strong>{' '}
                    identifies toxins that need to be processed.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-113">
                  <div className="bg-emerald-100 text-emerald-700 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1 font-bold text-xs" data-id="element-114">
                    2
                  </div>
                  <span className="text-slate-700" data-id="element-115">
                    <strong className="text-slate-900" data-id="element-116">Phase 2</strong>{' '}
                    neutralizes them so they're safe to eliminate.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-117">
                  <div className="bg-emerald-100 text-emerald-700 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1 font-bold text-xs" data-id="element-118">
                    3
                  </div>
                  <span className="text-slate-700" data-id="element-119">
                    <strong className="text-slate-900" data-id="element-120">Phase 3</strong> removes
                    them from the body completely.
                  </span>
                </li>
              </ul>

              <p data-id="element-121">Sounds simple, right?</p>

              <p data-id="element-122">
                But here's where it gets complicated. Each phase needs specific
                nutrients to work properly.
              </p>

              <p data-id="element-123">
                Phase 1 needs methylated B vitamins (especially B6, B9, and
                B12). Phase 2 needs magnesium and zinc. Phase 3 needs specific
                amino acids and minerals.
              </p>

              <p data-id="element-124">
                When even ONE of these nutrients is missing, the entire system
                starts to fail.
              </p>

              <p data-id="element-125">
                It's like a factory assembly line. If one station stops working,
                everything backs up. The whole production shuts down.
              </p>

              <p className="font-bold text-slate-900" data-id="element-126">
                That's the "cascade collapse."
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-127">
                The Vicious Cycle No One Talks About
              </h2>

              <p data-id="element-128">
                So what happens when your child's body can't clear toxins
                properly?
              </p>

              <p data-id="element-129">
                The small amounts of heavy metals from food—yes, even "healthy"
                food—don't get processed out. They accumulate.
              </p>

              <p data-id="element-130">Day after day. Week after week.</p>

              <p data-id="element-131">
                You may have heard about the 2021 Congressional report that
                found dangerous levels of heavy metals in 95% of baby foods.
                Arsenic, lead, cadmium, mercury. In the organic baby food you
                trusted.
              </p>

              <p data-id="element-132">
                That report was real. Those toxins are real. And they're not
                just in baby food.
              </p>

              <p data-id="element-133">
                They're in rice cereals, fruit pouches, even some vegetables.
                Not at levels that cause acute poisoning, but at levels that
                build up over time when your child's body can't process them
                out.
              </p>

              <p data-id="element-134">And as these toxins accumulate, they start affecting:</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-8 not-prose" data-id="element-135">
                {['Focus and attention', 'Emotional regulation', 'Sleep quality', 'Impulse control', 'Mood stability'].map(item => <div key={item} className="flex items-center gap-2 bg-slate-50 p-3 rounded-lg border border-slate-100" data-id="element-136">
                    <AlertCircle size={18} className="text-red-500" data-id="element-137" />
                    <span className="font-medium text-slate-700" data-id="element-138">{item}</span>
                  </div>)}
              </div>

              <p data-id="element-139">Sound familiar?</p>

              <p data-id="element-140">
                Here's the heartbreaking truth: The very symptoms parents
                attribute to ADHD are often being made worse by nutritional gaps
                that prevent the body from clearing environmental toxins.
              </p>

              <h3 className="font-sans font-bold text-xl text-slate-900 mt-8 mb-4" data-id="element-141">
                The Picky Eater Problem
              </h3>

              <img src="https://cdn.magicpatterns.com/uploads/dCzkq51n2cnRgt6bHAw7AB/ChatGPT_Image_26_Ιαν_2026,_03_21_06_μ.μ..png" alt="Child refusing healthy vegetables at dinner table" className="w-full rounded-xl my-8 shadow-lg" data-id="element-142" />

              <p data-id="element-143">
                And if your child is a picky eater—if they only eat 5-8 foods
                total—they're almost certainly deficient in these exact
                nutrients.
              </p>

              <p data-id="element-144">
                Chicken nuggets, fries, crackers, pasta, maybe some fruit
                pouches. That's the diet, right?
              </p>

              <p data-id="element-145">
                These foods don't contain the methylated B vitamins your child
                needs. They're low in magnesium and zinc. They don't provide the
                building blocks for the body's natural detoxification system.
              </p>

              <p data-id="element-146">
                So every day, the toxic backlog gets a little bigger. The system
                gets a little more overwhelmed.
              </p>

              <p data-id="element-147">
                And the focus problems, the emotional dysregulation, the sleep
                issues... they all get worse.
              </p>

              <p className="font-bold text-slate-900" data-id="element-148">
                This is the Micronutrient Cascade Collapse in action.
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-149">
                Why Everything You've Tried Hasn't Worked
              </h2>

              <p data-id="element-150">
                Let's talk about what you've probably already spent money on.
              </p>

              <ul className="not-prose space-y-4 my-6" data-id="element-151">
                <li className="flex gap-3" data-id="element-152">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-153" />
                  <span className="text-slate-700" data-id="element-154">
                    <strong data-id="element-155">Standard kids' multivitamins</strong> give your
                    child some basic vitamins. But they do nothing to support
                    detoxification. You're only addressing half the problem.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-156">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-157" />
                  <span className="text-slate-700" data-id="element-158">
                    <strong data-id="element-159">Detox-only products</strong> like zeolite drops try
                    to remove toxins. But without the nutritional foundation to
                    support all three phases, it's like trying to drain a pool
                    with a clogged filter.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-160">
                  <X className="text-red-500 flex-shrink-0 mt-1" data-id="element-161" />
                  <span className="text-slate-700" data-id="element-162">
                    <strong data-id="element-163">Liquid drops and tinctures?</strong> Even if they
                    have the right ingredients, getting your sensory-sensitive
                    child to take bitter liquids every single day is a battle
                    you'll lose.
                  </span>
                </li>
              </ul>

              <p data-id="element-164">
                The real problem? None of these approaches address both sides of
                the equation at the same time.
              </p>

              <p data-id="element-165">
                You need synchronized nutritional support AND detox support,
                working together, in a format your child will actually take.
              </p>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-166">
                The "Synchronized Nutrient-Detox Loading" Solution
              </h2>

              <p data-id="element-167">
                Dr. Martinez realized that if the problem was nutritional gaps
                preventing detoxification, the solution wasn't just vitamins OR
                detox support.
              </p>

              <p data-id="element-168">
                It was BOTH. At the same time. In precise ratios that activate
                all three phases of the detoxification system simultaneously.
              </p>

              <p data-id="element-169">
                She spent two years working with biochemists and pediatric
                specialists to create a formula that delivers:
              </p>

              <div className="bg-emerald-50 p-6 rounded-xl border border-emerald-100 my-8 not-prose" data-id="element-170">
                <ul className="space-y-3" data-id="element-171">
                  {["Methylated B vitamins (the form kids' bodies can actually use)", 'Magnesium and zinc in ratios specifically designed to support all three detox phases', 'Chlorella and zeolite (gentle binders that support natural toxin removal)', 'Complete multivitamin nutrition filling all the gaps from picky eating'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-172">
                      <div className="bg-emerald-500 rounded-full p-1 mt-0.5" data-id="element-173">
                        <Check size={12} className="text-white" strokeWidth={3} data-id="element-174" />
                      </div>
                      <span className="text-slate-800 font-medium" data-id="element-175">{item}</span>
                    </li>)}
                </ul>
              </div>

              <p data-id="element-176">All in ONE convenient gummy. All working together.</p>

              <p data-id="element-177">
                For the first time, you're activating all three phases of your
                child's detoxification system while providing complete
                nutritional support.
              </p>

              <h3 className="font-sans font-bold text-xl text-slate-900 mt-8 mb-4" data-id="element-178">
                But Here's The Game-Changer: Kids Actually Take It
              </h3>

              <p data-id="element-179">
                You can have the most scientifically perfect formula in the
                world. But if your child won't eat it, it's useless.
              </p>

              <p data-id="element-180">
                Dr. Martinez knew this. So she spent months taste-testing with
                dozens of picky eaters and sensory-sensitive children during
                formulation.
              </p>

              <p data-id="element-181">
                The result? A natural berry flavor sweetened with monk fruit
                (not high-fructose corn syrup) that kids genuinely enjoy.
              </p>

              <p data-id="element-182">Not "medicine good." Actually good.</p>

              <p data-id="element-183">
                Good enough that parents report their children asking for their
                "gummy vitamin" every morning instead of fighting it.
              </p>

              <div className="my-12 not-prose" data-id="element-184">
                <h3 className="font-sans font-bold text-3xl md:text-4xl text-slate-900 text-center mb-4" data-id="element-185">
                  Introducing Novyra™ Daily Balance Kids
                </h3>
                <p className="text-center text-slate-600 text-lg mb-8 max-w-2xl mx-auto" data-id="element-186">
                  The world's first synchronized nutrient-detox support gummy
                  designed specifically for the developing brain.
                </p>

                {/* Product Image */}
                <div className="flex justify-center mb-8" data-id="element-187">
                  <img src="https://cdn.magicpatterns.com/uploads/iNnfPsZXP6ZnRHDfnAAYqy/ChatGPT_Image_26_Ιαν_2026,_03_24_03_μ.μ..png" alt="Novyra Daily Balance Kids Gummies - 9 in 1 Supplement with colorful gummy bears" className="w-full max-w-2xl rounded-xl shadow-2xl" data-id="element-188" />
                </div>

                {/* Product Features */}
                <div className="bg-slate-50 rounded-xl p-6 md:p-8 border border-slate-200" data-id="element-189">
                  <div className="grid md:grid-cols-2 gap-8 mb-6" data-id="element-190">
                    <div data-id="element-191">
                      <h4 className="font-bold text-emerald-700 mb-4 uppercase tracking-wider text-sm" data-id="element-192">
                        Complete Nutritional Foundation
                      </h4>
                      <ul className="space-y-2 text-slate-700" data-id="element-193">
                        <li className="flex items-center gap-2" data-id="element-194">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-195" />
                          <span data-id="element-196">Methylated B-Complex (B6, B9, B12)</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-197">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-198" />
                          <span data-id="element-199">Vitamins C, D3, E</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-200">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-201" />
                          <span data-id="element-202">Zinc, Magnesium, Iron</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-203">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-204" />
                          <span data-id="element-205">Essential minerals for brain health</span>
                        </li>
                      </ul>
                    </div>
                    <div data-id="element-206">
                      <h4 className="font-bold text-emerald-700 mb-4 uppercase tracking-wider text-sm" data-id="element-207">
                        Gentle Detox Support
                      </h4>
                      <ul className="space-y-2 text-slate-700" data-id="element-208">
                        <li className="flex items-center gap-2" data-id="element-209">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-210" />
                          <span data-id="element-211">Chlorella (gentle binder)</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-212">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-213" />
                          <span data-id="element-214">Zeolite clinoptilolite</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-215">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-216" />
                          <span data-id="element-217">Antioxidant blend</span>
                        </li>
                        <li className="flex items-center gap-2" data-id="element-218">
                          <Check size={18} className="text-emerald-500 flex-shrink-0" data-id="element-219" />
                          <span data-id="element-220">Supports all 3 detox phases</span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* What's NOT in it */}
                  <div className="bg-white border-2 border-red-100 rounded-lg p-4" data-id="element-221">
                    <span className="font-bold text-red-700 block mb-3 text-sm uppercase tracking-wide" data-id="element-222">
                      What's NOT In It:
                    </span>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm text-slate-700" data-id="element-223">
                      <div className="flex items-center gap-2" data-id="element-224">
                        <X size={16} className="text-red-500 flex-shrink-0" data-id="element-225" />
                        <span data-id="element-226">No artificial dyes</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-227">
                        <X size={16} className="text-red-500 flex-shrink-0" data-id="element-228" />
                        <span data-id="element-229">No HFCS</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-230">
                        <X size={16} className="text-red-500 flex-shrink-0" data-id="element-231" />
                        <span data-id="element-232">No synthetic fillers</span>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-233">
                        <X size={16} className="text-red-500 flex-shrink-0" data-id="element-234" />
                        <span data-id="element-235">No gluten/dairy</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CTA */}
                <div className="text-center mt-8" data-id="element-236">
                  <Button onClick={scrollToOffer} size="xl" className="shadow-lg shadow-emerald-200" data-id="element-237">
                    CLAIM YOUR 30% OFF NOW
                  </Button>
                  <p className="text-sm text-slate-500 mt-3" data-id="element-238">
                    60-Day Money-Back Guarantee • Free Shipping • Third-Party
                    Tested
                  </p>
                </div>
              </div>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-239">
                What Parents Are Saying
              </h2>

              <img src="https://cdn.magicpatterns.com/uploads/bVyD2Q1bG6L3yuSgB1zwCu/ChatGPT_Image_26_Ιαν_2026,_03_27_21_μ.μ..png" alt="Happy mother and child doing homework together with Novyra gummies" className="w-full rounded-xl my-8 shadow-lg" data-id="element-240" />

              <div className="not-prose grid gap-6" data-id="element-241">
                <TestimonialCard headline="He actually asks for it now" quote="My 7-year-old son is SO picky and sensory-sensitive. Textures bother him, flavors bother him, everything bothers him. I was skeptical he'd even try these gummies. But he actually likes them! He asks for his 'gummy vitamin' every morning now. That alone is worth the price to me—but the fact that his teacher emailed me saying he's had two better weeks in a row? I'm genuinely speechless." author="Jennifer M." location="Portland, OR" avatarUrl="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-242" />
                <TestimonialCard headline="The email I never thought I'd get" quote="We've been dealing with daily teacher emails for two years. 'He can't focus.' 'He's disruptive.' 'He didn't finish his work again.' Every single day, my phone would buzz and my stomach would drop. After 3 weeks on Novyra, I got an email that made me cry: 'He had a GREAT day today!' No complaints. No calls. Just... a good day. We haven't changed anything else—same bedtime, same routine, same everything. The only difference is these gummies." author="Marcus T." location="Austin, TX" avatarUrl="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-243" />
                <TestimonialCard headline="Bedtime doesn't take 3 hours anymore" quote="Bedtime used to be a nightmare. We'd start the routine at 7 PM and my daughter still wouldn't be asleep until 10. She just couldn't calm down. Her body wouldn't settle. Within 2 weeks of starting Novyra, bedtime went from a 2-3 hour battle to about 30-40 minutes. She falls asleep easier and actually sleeps through the night now. I feel like I have my evenings back for the first time in years." author="Rachel K." location="Denver, CO" avatarUrl="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=100&h=100&q=80" data-id="element-244" />
              </div>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-245">
                "Another Supplement That Won't Work?"
              </h2>

              <p data-id="element-246">We understand.</p>
              <p data-id="element-247">
                You've spent hundreds—maybe thousands—on supplements that did
                nothing. Or worse, caused stomach issues and made things harder.
              </p>
              <p data-id="element-248">Here's why Novyra is different.</p>
              <p data-id="element-249">
                Most supplements are either nutrition OR detox. Never both
                working together at the same time.
              </p>
              <p data-id="element-250">
                And if your child has the Micronutrient Cascade Collapse—if
                their body lacks the specific nutrients needed to clear toxins
                properly—giving them only one side of the equation won't work.
              </p>

              <div className="bg-slate-100 p-6 rounded-lg my-8 not-prose" data-id="element-251">
                <h4 className="font-bold text-slate-900 mb-2" data-id="element-252">
                  Our 60-Day "Empty Bottle" Guarantee
                </h4>
                <p className="text-slate-700 mb-4" data-id="element-253">
                  If your child won't eat them, or if you don't see improvements
                  in focus, sleep, or behavior after 60 days, just return it.
                  We'll refund your money. No questions asked. No hoops to jump
                  through.
                </p>
                <div className="flex items-center gap-2 text-emerald-700 font-bold text-sm" data-id="element-254">
                  <ShieldCheck size={20} data-id="element-255" />
                  <span data-id="element-256">Risk-Free Trial</span>
                </div>
              </div>

              <h2 className="font-sans font-bold text-2xl md:text-3xl text-slate-900 mt-12 mb-6" data-id="element-257">
                Quick Answers To Common Questions
              </h2>

              <div className="not-prose space-y-2 mb-12" data-id="element-258">
                <FAQItem question="How long before I see results?" answer="Most parents report noticing changes within 2-3 weeks. Some see improvements in sleep quality within the first week. Others notice better focus and calmer transitions around week 3-4. Remember, you're rebuilding nutritional foundations and supporting detoxification pathways. It takes time for your child's body to catch up after months or years of nutritional gaps." data-id="element-259" />
                <FAQItem question="Can my child take this with ADHD medication?" answer="Novyra is a food-based supplement, but if your child is on medication (stimulant or non-stimulant), please check with your prescribing doctor before adding any new supplement to their routine." data-id="element-260" />
                <FAQItem question="What age is this recommended for?" answer="Ages 4 and up. For younger children, please consult your pediatrician first." data-id="element-261" />
                <FAQItem question="How many gummies per day?" answer="Two gummies daily provides the complete nutritional and detox support dose. They can be taken together in the morning or split (one morning, one evening)." data-id="element-262" />
                <FAQItem question="What if my child has food allergies?" answer="Novyra is free from the top 8 allergens: dairy, eggs, fish, shellfish, tree nuts, peanuts, wheat, and soy. The full ingredient list is printed on every bottle and available on our website." data-id="element-263" />
              </div>

              <div id="offer-section" className="bg-white border-2 border-emerald-500 rounded-2xl p-6 md:p-10 shadow-2xl my-12 not-prose relative overflow-hidden" data-id="element-264">
                <div className="absolute top-0 right-0 bg-emerald-500 text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-265">
                  LIMITED TIME OFFER
                </div>

                <h2 className="font-sans font-bold text-3xl text-slate-900 mb-2 text-center" data-id="element-266">
                  Special Offer For New Customers
                </h2>
                <p className="text-center text-slate-600 mb-8" data-id="element-267">
                  Save 30% on your first month of Novyra™ Daily Balance Kids
                </p>

                <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-268">
                  <div className="flex-1" data-id="element-269">
                    <ul className="space-y-3" data-id="element-270">
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-271">
                        <Check size={20} className="text-emerald-500" data-id="element-272" /> 30-Day
                        Supply
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-273">
                        <Check size={20} className="text-emerald-500" data-id="element-274" />{' '}
                        Sugar-Free & Dye-Free
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-275">
                        <Check size={20} className="text-emerald-500" data-id="element-276" /> 60-Day
                        Money-Back Guarantee
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-277">
                        <Check size={20} className="text-emerald-500" data-id="element-278" />{' '}
                        Third-Party Tested
                      </li>
                      <li className="flex items-center gap-2 text-slate-700" data-id="element-279">
                        <Check size={20} className="text-emerald-500" data-id="element-280" /> Free
                        Shipping
                      </li>
                    </ul>
                  </div>

                  <div className="flex-1 w-full" data-id="element-281">
                    <Button fullWidth size="xl" onClick={scrollToOffer} className="mb-3 shadow-emerald-200 shadow-xl" data-id="element-282">
                      GET 30% OFF NOVYRA™ TODAY
                    </Button>
                    <div className="flex items-center justify-center gap-4 text-xs text-slate-500" data-id="element-283">
                      <span className="flex items-center gap-1" data-id="element-284">
                        <Truck size={12} data-id="element-285" /> Free Shipping
                      </span>
                      <span className="flex items-center gap-1" data-id="element-286">
                        <Clock size={12} data-id="element-287" /> Cancel Anytime
                      </span>
                    </div>
                  </div>
                </div>

                <p className="text-center text-sm text-slate-500 italic" data-id="element-288">
                  "You have nothing to lose. And potentially everything to gain.
                  Your child is doing their best with what their body has. What
                  if you could finally give them what they've been missing all
                  along?"
                </p>
              </div>
            </article>
          </main>

          {/* Sticky Sidebar CTA - Desktop Only */}
          <aside className="hidden lg:block" data-id="element-289">
            <StickyCTA onCtaClick={scrollToOffer} data-id="element-290" />
          </aside>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-50 border-t border-slate-200 py-12 px-4" data-id="element-291">
        <div className="max-w-3xl mx-auto text-center" data-id="element-292">
          <div className="mb-8" data-id="element-293">
            <div className="font-bold text-xl tracking-tight text-slate-900 mb-4" data-id="element-294">
              Novyra<span className="text-emerald-600" data-id="element-295">™</span>
            </div>
            <p className="text-sm text-slate-500 max-w-lg mx-auto" data-id="element-296">
              Customer Support: trynovyra@gmail.com
            </p>
          </div>

          <div className="text-[10px] text-slate-400 space-y-4 leading-relaxed border-t border-slate-200 pt-8" data-id="element-297">
            <p data-id="element-298">
              These statements have not been evaluated by the Food and Drug
              Administration. This product is not intended to diagnose, treat,
              cure, or prevent any disease. Results may vary. Individual results
              may vary, testimonials are not claimed to represent typical
              results.
            </p>
            <p data-id="element-299">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. Any photographs of persons used on
              this site are models.
            </p>
            <div className="flex justify-center gap-4 pt-4" data-id="element-300">
              <a href="#" className="hover:text-slate-600" data-id="element-301">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-slate-600" data-id="element-302">
                Terms of Service
              </a>
              <a href="#" className="hover:text-slate-600" data-id="element-303">
                Ingredients
              </a>
            </div>
            <p className="pt-4" data-id="element-304">© 2025 Novyra Health. All rights reserved.</p>
          </div>
        </div>
      </footer>

      {/* Mobile Sticky CTA - Enhanced Version */}
      <div className={`fixed bottom-0 left-0 right-0 bg-white border-t-2 border-emerald-500 shadow-[0_-8px_16px_-4px_rgba(0,0,0,0.15)] transition-transform duration-300 z-50 lg:hidden ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-305">
        <div className="p-4" data-id="element-306">
          <div className="flex items-center justify-between mb-3" data-id="element-307">
            <div data-id="element-308">
              <p className="font-bold text-sm text-slate-900" data-id="element-309">
                Help Your Child Focus
              </p>
              <div className="flex items-center gap-1" data-id="element-310">
                {[...Array(5)].map((_, i) => <Star key={i} size={12} fill="#FCD34D" className="text-yellow-400" data-id="element-311" />)}
                <span className="text-xs text-slate-600 ml-1" data-id="element-312">4.8 (3,791)</span>
              </div>
            </div>
            <div className="bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-313">
              30% OFF
            </div>
          </div>
          <Button fullWidth onClick={scrollToOffer} size="lg" data-id="element-314">
            CHECK AVAILABILITY →
          </Button>
          <p className="text-[10px] text-center text-slate-500 mt-2" data-id="element-315">
            60-Day Guarantee • Free Shipping
          </p>
        </div>
      </div>
    </div>;
}